module.exports = __webpack_public_path__ + "media/images/countryrect/mf-1f61a748c2daa4e7c31156b8bad3efbc.svg";